import { takeEvery } from 'redux-saga/effects';

import { ActionTypes } from '../constants';
import { addScreen } from './addScreen';

export default [
  takeEvery(ActionTypes.ADD_SCREEN, addScreen),
];
